// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalForm_wrapper__KTNVW","show":"ModalForm_show__1STuA","modal":"ModalForm_modal__7HP8N"};